
<topmenu></topmenu>
<app-toasts></app-toasts>
<url-couponcode></url-couponcode>
<drawer [lang]="preferredlanguage"></drawer>
<div class="min-h-screen bg-e-white">
    <router-outlet>
    </router-outlet>
</div>


